import React from 'react';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import Accordion from 'app-ui-componentlibrary/dist/go/components/common/accordion/Accordion';
import {TextAreaFieldFrom as TextAreaField} from 'app-ui-componentlibrary';
import {
  MitigationInformation,
  LocationInformation,
  StructureAttributes,
  InsuranceInformation,
  OwnerInformation,
  CostEffectivenessInformation,
  GreenspaceAcreage,
} from 'go/components/dynamic/modules/projectSiteInventory/sections';
import {Grid, Button, Dropdown, Loader} from 'semantic-ui-react';
import {
  mapLocationRefDataByIdOrCode,
  mapLocationRefDataByIdAndCode,
  mapLocationRefDataByCode,
} from 'common/utils';
import {
  INVENTORY_ITEM_ATTACHMENT,
  SECTIONS_LABELS,
  RESIDENCE_STRUCTURE_TYPES,
  PROPERTY_TYPES_CODES,
} from './constants';
import {SAVE_LOCATION_ENTITY} from 'common/types';
import location from 'go/actions/api/location';

import _ from 'lodash';
import {produce} from 'immer';
import {
  isLocationBuildingInventoryType,
  isLocationInfrastructureInventoryType,
} from 'go/components/dynamic/modules/projectSiteInventory/utils';

export class ProjectSiteItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
      activeSection: _.camelCase(SECTIONS_LABELS.PRIMARY_MITIGATION_ACTION),
      locationType: this.props.locationType,
      allActs: {},
      validation: {},
      validationDirtyMap: {},
      allDirty: false,
      displayType: 'add',
    };
  }

  UNSAFE_componentWillMount() {
    if (this.props.displayType === 'edit') {
      let allDirty = true;
      this.setState({
        allDirty: allDirty,
        displayType: this.props.displayType,
      });
    }
  }

  autoSave = () => {
    this.props.updateProjectSiteDetails(this.props.token, this.props.inventoryItem);
  };

  debouncedAutoSave = _.debounce(() => {
    this.autoSave();
  }, 250);

  componentDidMount() {
    this.generateOptions();
  }

  // Generate options from ref data
  generateOptions = () => {
    const {context} = this.props;

    let structureTypes = mapLocationRefDataByIdAndCode(
      _.get(context, 'structureTypes.STRUCTURE_TYPE'),
      'code'
    );

    let propertyOwnerTypes = mapLocationRefDataByIdOrCode(
      _.get(context, 'propertyOwnerTypes.PROPERTY_OWNER_TYPE'),
      'code'
    );

    let propertyInventoryTypes = mapLocationRefDataByIdOrCode(
      _.get(context, 'propertyInventoryTypes.PROPERTY_INVENTORY_TYPE'),
      'code'
    );
    let benefitCostTypes = mapLocationRefDataByIdOrCode(
      _.get(context, 'benefitCostTypes.BENEFIT_COST_TYPE'),
      'code'
    );

    let propertyFoundationTypes = mapLocationRefDataByIdOrCode(
      _.get(context, 'propertyFoundationTypes.PROPERTY_FOUNDATION_TYPE'),
      'code'
    );

    let floodZoneTypes = mapLocationRefDataByIdOrCode(
      _.get(context, 'floodZoneTypes.FLOOD_ZONE_TYPE'),
      'code'
    );
    let hazardTypes = mapLocationRefDataByIdOrCode(
      _.get(context, 'hazardSources.HAZARD_SOURCE'),
      'code'
    );
    let natureBasedSolutions = mapLocationRefDataByIdOrCode(
      _.get(context, 'natureBasedSolutions.NATURE_BASED_SOLUTION'),
      'code'
    );
    let usStates = mapLocationRefDataByIdOrCode(
      _.get(context, 'loadStates.STATE'),
      'code'
    );

    let landUseTypes = mapLocationRefDataByIdAndCode(
      _.get(context, 'landUseTypes.INVENTORY_LAND_USE'),
      'code'
    );

    let suffix = [
      {key: 'SR', value: 'SR', text: 'SR'},
      {key: 'JR', value: 'JR', text: 'JR'},
      {key: 'II', value: 'II', text: 'II'},
      {key: 'III', value: 'III', text: 'III'},
      {key: 'IV', value: 'IV', text: 'IV'},
      {key: 'V', value: 'V', text: 'V'},
      {key: 'VI', value: 'VI', text: 'VI'},
      {key: 'MD', value: 'MD', text: 'MD'},
      {key: 'PHD', value: 'PHD', text: 'PHD'},
      {key: 'DDS', value: 'DDS', text: 'DDS'},
    ];

    const mitigationActions = this.generateMitigationActions(this.props.locationType);

    const options = {
      structureTypes,
      propertyOwnerTypes,
      propertyInventoryTypes,
      benefitCostTypes,
      propertyFoundationTypes,
      floodZoneTypes,
      hazardTypes,
      natureBasedSolutions,
      usStates,
      suffix,
      mitigationActions,
      landUseTypes,
      residenceStructureType: RESIDENCE_STRUCTURE_TYPES,
    };
    this.setState({options});
  };

  generateMitigationActions = (inventoryType) => {
    let mitigationActions = _.get(this.props, 'context.programCategoryConfig.structures');
    let mitigationActionsRef = _.get(
      this.props,
      'context.mitigationActionTypes.MITIGATION_ACTION'
    );

    let buildingMitigationActions = _.filter(mitigationActions, (obj) => {
      return obj.type === inventoryType;
    });
    if (!_.isEmpty(buildingMitigationActions)) {
      let primeSubList = _.map(
        _.get(buildingMitigationActions, '0.mitigationActions', []),
        (entry) => {
          let text2 = _.filter(mitigationActionsRef, (x) => {
            return Number(x.id) === Number(entry.mitigationActionId);
          });
          if (!_.isEmpty(text2)) {
            return {
              key: _.get(text2, '0.id'),
              value: _.get(text2, '0.code'),
              text: _.get(text2, '0.displayText'),
            };
          }
        }
      );

      var filtered = primeSubList.filter(function (el) {
        return el != null;
      });
      return filtered;
    }
  };

  handleChange = (e) => {
    const {name, value, type, checked} = e.target;

    //Reset Structure Types Primary options when user changes Structure Types
    if (name === 'structure.structureType') {
      this.props.saveLocationEntity({
        dataPath: 'structure.structureTypePrimary',
        value: null,
      });

      this.props.saveLocationEntity({
        dataPath: 'structure.structureTypeSecondary',
        value: null,
      });
    }

    if (name === 'structure.structureTypePrimary') {
      this.props.saveLocationEntity({
        dataPath: 'structure.structureTypeSecondary',
        value: null,
      });
    }

    this.props.saveLocationEntity({
      dataPath: name,
      value: type == 'select-one' && value === 'Select' ? null : value, // Select is a default/empty value of the dropdown
    });
  };

  handleStructureTypeChange = (name, value, extras) => {
    const NEEDS_VALUE = 'NEEDS_VALUE'; // Trigger back end validation
    const {needsPrimary, needsSecondary} = extras;

    if (name === 'structure.structureType') {
      this.props.saveLocationEntity({
        dataPath: 'structure.structureTypePrimary',
        value: needsPrimary ? NEEDS_VALUE : null,
      });

      this.props.saveLocationEntity({
        dataPath: 'structure.structureTypeSecondary',
        value: null,
      });
    }

    if (name === 'structure.structureTypePrimary') {
      this.props.saveLocationEntity({
        dataPath: 'structure.structureTypeSecondary',
        value: needsSecondary ? NEEDS_VALUE : null,
      });
    }
    this.props.saveLocationEntity({
      dataPath: name,
      value: value,
    });
  };

  handleNameValueChange = (name, value) => {
    this.props.saveLocationEntity({
      dataPath: name,
      value: value,
    });
  };

  handleMultiSelect = (name, selected) => {
    const nextState = produce(this.state.inventoryItem, (draft) => {
      if (name === 'payload.primaryHazards') {
        _.set(draft, name, [selected]); // save as an array with one element
      }
      if (name === 'payload.secondaryHazards') {
        _.set(draft, name, selected);
      }
    });
    this.setState({inventoryItem: nextState});
  };

  handleChangeOnDollarAmount = (name, value) => {
    this.handleNameValueChange(name, value);
  };

  handleChangeBoolean = (e) => {
    let booleanValue = true;
    if (e.target.value === 'true') booleanValue = true;
    else booleanValue = false;
    this.props.saveLocationEntity({
      dataPath: e.target.name,
      value: booleanValue,
    });
  };

  handleChangePhoneNumber = (e) => {
    const {name, value} = e.target;
    let newValue = value.replace(/\D/, '');
    this.props.saveLocationEntity({
      dataPath: name,
      value: newValue,
    });
  };

  handleChangeSpecialChar = (e) => {
    const {name, value} = e.target;
    let newValue = value.replace(/[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]+/, '');
    this.props.saveLocationEntity({
      dataPath: name,
      value: newValue,
    });
  };
  handleChangeNumerical = (e) => {
    const {name, value} = e.target;
    this.props.saveLocationEntity({
      dataPath: name,
      value: value,
    });
  };

  displayError = (path) => {
    let dirtyValue = _.get(this.state.validationDirtyMap, path);
    if (this.state.allDirty || dirtyValue === true) {
      let error = _.filter(this.props.inventoryItem.errors, (x) => {
        if (path === 'payload.primaryHazards') {
          return x.path === path + '[0]' || x.path === path;
        } else {
          return x.path === path;
        }
      });

      if (!_.isEmpty(error)) return true;
    }
  };

  getErrorMessage = (path, message) => {
    let error = _.filter(this.props.inventoryItem.errors, (x) => {
      if (path === 'payload.primaryHazards') {
        return x.path === path + '[0]' || x.path === path;
      } else {
        return x.path === path;
      }
    });

    const firstError = _.find(error, {validationType: 'custom'}) || _.first(error);
    // Show custom message only.
    // Others messages are generated by JSON validator and not user-friendly
    if (
      !_.isEmpty(firstError) &&
      !_.isEmpty(_.get(firstError, 'message')) &&
      _.get(firstError, 'validationType') === 'custom'
    ) {
      return _.get(firstError, 'message');
    } else if (path === 'payload.insurance.propertyInsured') {
      return 'Please enter a response';
    } else if (path === 'payload.insurance.privateInsured') {
      return 'Please select at least one option';
    } else {
      return this.displayErrorMsgForRequiredField(message);
    }
  };

  handleBlur = (e) => {
    const {name} = e.target;
    this.autoSave();

    // Delaying setting validationDirtyMap so save completes and new list of errors comes back
    this.debouncedSetState({
      validationDirtyMap: {
        ...this.state.validationDirtyMap,
        [name]: true,
      },
    });
  };

  handleMultiSelectBlur = (e, data) => {
    const {name} = data;
    this.autoSave();

    // Delaying setting validationDirtyMap so save completes and new list of errors comes back
    this.debouncedSetState({
      validationDirtyMap: {
        ...this.state.validationDirtyMap,
        [name]: true,
      },
    });
  };

  debouncedSetState = _.debounce((obj) => {
    this.setState(obj);
  }, 500);

  saveCostMitigation = (name) => {
    this.setState({
      validationDirtyMap: {
        ...this.state.validationDirtyMap,
        [name]: true,
      },
    });
    this.autoSave();
  };

  saveBenefitCostRatio = (e) => {
    const {name, value} = e.target;
    if (!isNaN(_.toNumber(value))) {
      this.props.saveLocationEntity({
        dataPath: name,
        value: value,
      });
    }
  };

  savePositiveNumber = (e) => {
    const {name, value} = e.target;
    if (!isNaN(_.toNumber(value)) && !_.includes(value, '.') && 0 <= _.toNumber(value)) {
      this.props.saveLocationEntity({
        dataPath: name,
        value: value,
      });
    }
  };

  displayErrorMsgForRequiredField = (name) => {
    return name === 'Foundation type' ||
      'Structure type primary indicator' ||
      'Structure type secondary indicator'
      ? [`${name} is required`]
      : [`Enter a valid ${name}`];
  };

  handleFormattedValue = (name, value) => {
    const nextState = produce(this.state.inventoryItem, (draft) => {
      if (name) {
        _.set(draft, name, [value]);
      }
    });
    this.setState({inventoryItem: nextState});
  };

  saveValue = (name, value) => {
    this.props.saveLocationEntity({
      dataPath: name,
      value: value,
    });
    this.debouncedAutoSave();
  };

  renderMitigationInformation = () => {
    const {options} = this.state;
    const {displayType, locationType, inventoryItem} = this.props;
    if (inventoryItem.projectSiteInventory?.location === undefined)
      return <p>No data available</p>;

    return (
      <MitigationInformation
        displayType={displayType}
        locationType={locationType}
        inventoryItem={inventoryItem}
        options={options}
        validation={this.state.validation}
        handleChange={this.handleChange}
        handleMultiSelect={this.handleMultiSelect}
        displayError={this.displayError}
        getErrorMessage={this.getErrorMessage}
        handleBlur={this.handleBlur}
        {...this.props}
      />
    );
  };

  renderLocationInformation = () => {
    const {options} = this.state;
    const {displayType, locationType, inventoryItem} = this.props;
    if (inventoryItem.projectSiteInventory?.location === undefined)
      return <p>No data available</p>;
    return (
      <LocationInformation
        displayType={displayType}
        locationType={locationType}
        inventoryItem={inventoryItem}
        options={options}
        validation={this.state.validation}
        {...this.props}
        handleChange={this.handleChange}
        handleChangeNumerical={this.handleChangeNumerical}
        displayError={this.displayError}
        getErrorMessage={this.getErrorMessage}
        handleBlur={this.handleBlur}
        handleFormattedValue={this.handleFormattedValue}
        saveValue={this.saveValue}
      />
    );
  };

  renderStructureAttributes = () => {
    const {options} = this.state;
    const {displayType, locationType, inventoryItem} = this.props;
    if (!inventoryItem.structure) return <p>No data available</p>;
    return (
      <StructureAttributes
        displayType={displayType}
        locationType={locationType}
        inventoryItem={inventoryItem}
        options={options}
        validation={this.state.validation}
        resetPrimarySecondaryStructureTypesOptions={
          this.resetPrimarySecondaryStructureTypesOptions
        }
        {...this.props}
        handleChange={this.handleChange}
        handleStructureTypeChange={this.handleStructureTypeChange}
        handleChangeBoolean={this.handleChangeBoolean}
        handleChangeOnDollarAmount={this.handleChangeOnDollarAmount}
        handleChangeNumerical={this.handleChangeNumerical}
        displayError={this.displayError}
        getErrorMessage={this.getErrorMessage}
        handleBlur={this.handleBlur}
        saveCostMitigation={this.saveCostMitigation}
      />
    );
  };

  renderInsuranceInformation = () => {
    const {options} = this.state;
    const {displayType, locationType, inventoryItem} = this.props;
    return (
      <InsuranceInformation
        displayType={displayType}
        locationType={locationType}
        inventoryItem={inventoryItem}
        options={options}
        {...this.props}
        validation={this.state.validation}
        handleChange={this.handleChange}
        handleChangeSpecialChar={this.handleChangeSpecialChar}
        handleChangeBoolean={this.handleChangeBoolean}
        displayError={this.displayError}
        getErrorMessage={this.getErrorMessage}
        handleBlur={this.handleBlur}
      />
    );
  };

  renderCostEffectivenessInformation = () => {
    const {options} = this.state;
    const {displayType, locationType, inventoryItem} = this.props;
    return (
      <CostEffectivenessInformation
        displayType={displayType}
        locationType={locationType}
        inventoryItem={inventoryItem}
        options={options}
        {...this.props}
        validation={this.state.validation}
        handleChange={this.handleChange}
        handleNameValueChange={this.handleNameValueChange}
        handleChangeNumerical={this.handleChangeNumerical}
        handleChangeBoolean={this.handleChangeBoolean}
        displayError={this.displayError}
        getErrorMessage={this.getErrorMessage}
        handleBlur={this.handleBlur}
        handleMultiSelectBlur={this.handleMultiSelectBlur}
        saveBenefitCostRatio={this.saveBenefitCostRatio}
      />
    );
  };

  renderGreenspaceAcreage = () => {
    const {options} = this.state;
    const {displayType, locationType, inventoryItem} = this.props;
    return (
      <GreenspaceAcreage
        displayType={displayType}
        locationType={locationType}
        inventoryItem={inventoryItem}
        options={options}
        {...this.props}
        validation={this.state.validation}
        handleChange={this.handleChange}
        handleNameValueChange={this.handleNameValueChange}
        handleChangeNumerical={this.handleChangeNumerical}
        handleChangeBoolean={this.handleChangeBoolean}
        handleChangeNumber={this.savePositiveNumber}
        displayError={this.displayError}
        getErrorMessage={this.getErrorMessage}
        handleBlur={this.handleBlur}
      />
    );
  };

  renderOwnerInformation = () => {
    const {options} = this.state;
    const {displayType, locationType, inventoryItem} = this.props;

    return (
      <OwnerInformation
        displayType={displayType}
        locationType={locationType}
        inventoryItem={inventoryItem}
        options={options}
        validation={this.state.validation}
        {...this.props}
        handleChange={this.handleChange}
        handleChangeBoolean={this.handleChangeBoolean}
        handleChangeNumerical={this.handleChangeNumerical}
        handleChangePhoneNumber={this.handleChangePhoneNumber}
        displayError={this.displayError}
        getErrorMessage={this.getErrorMessage}
        handleBlur={this.handleBlur}
      />
    );
  };

  handleExpand = (e, {name}) => {
    this.setState({
      activeSection: this.state.activeSection === name ? '' : name,
    });
  };

  render() {
    const {displayType, context, inventoryItem, locationType} = this.props;
    const isBuilding = isLocationBuildingInventoryType(locationType);

    const sections = [
      {
        id: _.camelCase(SECTIONS_LABELS.PRIMARY_MITIGATION_ACTION),
        name: SECTIONS_LABELS.PRIMARY_MITIGATION_ACTION,
        content: this.renderMitigationInformation(),
      },
      {
        id: _.camelCase(SECTIONS_LABELS.LOCATION_INFORMATION),
        name: SECTIONS_LABELS.LOCATION_INFORMATION,
        content: this.renderLocationInformation(),
      },
      {
        id: _.camelCase(SECTIONS_LABELS.STRUCTURE_ATTRIBUTES),
        name: SECTIONS_LABELS.STRUCTURE_ATTRIBUTES,
        content: this.renderStructureAttributes(),
      },
      {
        id: _.camelCase(SECTIONS_LABELS.INSURANCE_INFORMATION),
        name: isBuilding
          ? SECTIONS_LABELS.BUILDING_INSURANCE_INFORMATION
          : SECTIONS_LABELS.INFRASTRUCTURE_INSURANCE_INFORMATION,
        content: this.renderInsuranceInformation(),
      },
      {
        id: _.camelCase(SECTIONS_LABELS.COST_EFFECTIVENESS_INFORMATION),
        name: SECTIONS_LABELS.COST_EFFECTIVENESS_INFORMATION,
        content: this.renderCostEffectivenessInformation(),
      },
      this.props.includeNatureBasedSolutions && {
        id: _.camelCase(SECTIONS_LABELS.GREENSPACE_ACREAGE),
        name: SECTIONS_LABELS.GREENSPACE_ACREAGE,
        content: this.renderGreenspaceAcreage(),
      },
      {
        id: _.camelCase(SECTIONS_LABELS.OWNER_INFORMATION),
        name: SECTIONS_LABELS.OWNER_INFORMATION,
        content: this.renderOwnerInformation(),
      },
    ].filter((id) => id);

    return (
      <div className="project-site-item-wrapper">
        <div id="project-site-inventory-item-accordion">
          <Accordion
            sections={sections}
            handleExpand={this.handleExpand}
            activeSection={this.state.activeSection}
          />
        </div>
        <Grid.Row>
          <Grid.Column mobile={16} computer={16}>
            <div id="additional-comments" className="location-method">
              {displayType === 'view' ? (
                <React.Fragment>
                  <p className="label half-col psi-label">
                    Additional comments <span>(Optional)</span>
                  </p>
                  {inventoryItem.projectSiteInventory?.additionalComments}
                </React.Fragment>
              ) : (
                <div className="util--full-width ui form">
                  <TextAreaField
                    label="Provide additional comments about the location below. (Optional)"
                    maxLength={4000}
                    id="additional-comments-control"
                    title="Provide additional comments about the location below. (Optional)"
                    name="additionalComments"
                    value={inventoryItem.additionalComments}
                    handleChange={this.handleChange}
                    handleBlur={this.handleBlur}
                  />
                </div>
              )}
            </div>
          </Grid.Column>
        </Grid.Row>
      </div>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    context: state.dynamicComponent.context,
    data: state.dynamicComponent.data,
    inventoryItem: state.locationSiteData.inventoryItem,
  };
};

export const mapDispatchToProps = (dispatch) => ({
  saveLocationEntity: (payload) => {
    return dispatch({
      type: SAVE_LOCATION_ENTITY,
      data: payload,
    });
  },
  updateProjectSiteDetails: (token, inventoryItem) => {
    dispatch(location.updateProjectSiteDetails(token, inventoryItem));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(connectDynamic(ProjectSiteItem));
